module.exports = __webpack_public_path__ + "media/creditcard/amex-07acbe5e.png";